// extracted by mini-css-extract-plugin
module.exports = {"root":"AddImages_root__1_6D3"};